import React from 'react';
import TableCell, { TableCellProps } from '@mui/material/TableCell';

import { styled } from '@mui/material/styles';

const CustomTableCell = styled(TableCell)({
	padding: '10px 10px',

	borderBottom: 'none',
});


export const TableCellHead: React.FC<TableCellProps> = (props) => {
	const { children, ...otherProps } = props;
	return (
		<CustomTableCell {...otherProps}>
			{children}
		</CustomTableCell>
	);
};
